import {
  germanPostalCodeRegex,
  internationalPhoneNumberRegex,
  isEmailDomainAllowed,
} from "use-smart-locks-shared";
import * as Yup from "yup";

export const emailValidation = Yup.string()
  .email("Ungültige E-Mail-Adresse")
  .required("E-Mail ist erforderlich");

export const createEmailValidation = (
  allowedEmailDomains: string[] = [],
): Yup.StringSchema<string> => {
  if (allowedEmailDomains.length === 0) {
    return emailValidation;
  }

  return emailValidation.test(
    "allowed-email-domain",
    `Bitte verwenden Sie eine E-Mail-Adresse von ${allowedEmailDomains.join(", ")}.`,
    (value) => !value || isEmailDomainAllowed(value, allowedEmailDomains),
  );
};

export const passwordRequiredValidation = Yup.string().required(
  "Passwort ist erforderlich",
);

export const strongPasswordValidation = Yup.string()
  .required("Passwort ist erforderlich")
  .min(8, "Passwort muss mindestens 8 Zeichen lang sein")
  .matches(/[a-z]/, "Passwort muss mindestens einen Kleinbuchstaben enthalten")
  .matches(/[A-Z]/, "Passwort muss mindestens einen Großbuchstaben enthalten")
  .matches(/[0-9]/, "Passwort muss mindestens eine Zahl enthalten")
  .matches(
    /[^A-Za-z0-9]/,
    "Passwort muss mindestens ein Sonderzeichen enthalten",
  );

export const internationalPhoneNumberValidation = Yup.string()
  .trim()
  .required("Telefonnummer ist erforderlich")
  .matches(
    internationalPhoneNumberRegex,
    "Bitte gib eine gültige internationale Telefonnummer ein",
  );

export const germanPostalCodeValidation = Yup.string()
  .trim()
  .required("PLZ ist erforderlich")
  .matches(germanPostalCodeRegex, "PLZ muss genau 5 Ziffern haben");
